/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import section3 from 'static/main/section3.png';

const Section3 = () => {
  const { mq } = useTheme();

  const section3Style = css`
    .container {
      max-width: 1535px;
      padding: 140px 40px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h2 {
        font-size: 56px;
        font-weight: 600;
        line-height: 76px;
        span {
          color: #6079ff;
          font-size: inherit;
          font-weight: inherit;
        }
      }
      .text {
        line-height: 28px;
        font-size: 18px;
      }
      img {
        width: 800px;
      }
    }
    ${mq.mobile} {
      .container {
        flex-direction: column-reverse;
        padding: 0;
        .left {
          width: 100%;
          padding: 35px 32px 83px 32px;
          h2 {
            font-size: 28px;
            font-weight: 700;
            line-height: 36px;
          }
          .text {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            margin-top: 4px;
          }
        }
        img {
          width: 100%;
        }
      }
    }
  `;
  return (
    <div css={section3Style}>
      <div className="container">
        <div className="left">
          <h2>
            멋진 화면과 메뉴를
            <br />
            <span>내 맘대로</span>
          </h2>
          <div className="text">
            쇼핑몰의 첫 화면과 메뉴를 멋지게 꾸며보세요. <br />
            그리고 다양한 상품을 내가 원하는 메뉴로
            <br /> 구성할 수 있습니다.
          </div>
        </div>
        <div className="right">
          <img src={section3} alt="section3" />
        </div>
      </div>
    </div>
  );
};

export default Section3;
